import { STORE } from "@/data/site";

const GooglePlayIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" className="shrink-0">
    <path fill="currentColor" d="M3.6 2.3a1 1 0 0 0-.6.9v17.6a1 1 0 0 0 .6.9l10-9.7-10-9.7Z" opacity="0.9" />
    <path fill="currentColor" d="m14.9 9.5 3.8 2.1c.9.5.9 1.8 0 2.3l-3.8 2.1-2.7-2.6 2.7-3.9Z" opacity="0.7" />
    <path fill="currentColor" d="M4 2.1 15 8.5l-2.4 2.4L4 2.1Zm0 19.8 8.6-8.8L15 15.5 4 21.9Z" />
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" className="shrink-0">
    <path
      fill="currentColor"
      d="M16.4 12.6c0-2 1.6-3 1.7-3.1-1-1.4-2.4-1.6-2.9-1.6-1.2-.1-2.4.7-3 .7-.6 0-1.6-.7-2.6-.7-1.3 0-2.6.8-3.3 2-1.4 2.4-.4 6 1 8 .7 1 1.4 2.1 2.5 2 1-.1 1.3-.6 2.5-.6 1.2 0 1.5.6 2.6.6 1.1 0 1.7-1 2.4-2 .7-1.1 1-2.2 1-2.3-.1 0-2-.8-2-3ZM14.6 6.3c.6-.7 1-1.6.9-2.6-.8 0-1.9.6-2.5 1.3-.5.6-1 1.6-.9 2.5.9.1 1.8-.5 2.5-1.2Z"
    />
  </svg>
);

const Badge = ({ live, href, testid, Icon, top, bottom, size = "md" }) => {
  const pad = size === "lg" ? "px-6 py-3.5" : "px-5 py-3";
  return (
    <a
      href={live ? href : "#"}
      target={live ? "_blank" : undefined}
      rel={live ? "noopener noreferrer" : undefined}
      data-testid={testid}
      className={`group relative inline-flex items-center gap-3 border ${pad} font-body transition-colors duration-300 ${
        live
          ? "bg-ember text-charcoal border-ember hover:bg-white"
          : "bg-zinc-900/60 text-white border-zinc-700 hover:border-ember hover:text-ember"
      }`}
      aria-disabled={!live}
      onClick={(e) => {
        if (!live) e.preventDefault();
      }}
    >
      <Icon />
      <span className="flex flex-col leading-none text-left">
        <span className="text-[9px] md:text-[10px] tracking-[0.15em] uppercase opacity-70">{top}</span>
        <span className="font-semibold text-base md:text-lg -mt-0.5">{bottom}</span>
      </span>
      {!live && (
        <span className="absolute -top-2 -right-2 bg-ember text-charcoal text-[9px] font-bold px-1.5 py-0.5 uppercase tracking-wide">
          Soon
        </span>
      )}
    </a>
  );
};

export const StoreButtons = ({ className = "", stacked = false, size = "md" }) => {
  const gpLive = Boolean(STORE.googlePlay);
  const asLive = Boolean(STORE.appStore);
  return (
    <div
      className={`flex ${stacked ? "flex-col" : "flex-col sm:flex-row"} gap-3 ${className}`}
      data-testid="store-buttons"
    >
      <Badge
        live={gpLive}
        href={STORE.googlePlay}
        testid="cta-google-play"
        Icon={GooglePlayIcon}
        top="Get it on"
        bottom="Google Play"
        size={size}
      />
      <Badge
        live={asLive}
        href={STORE.appStore}
        testid="cta-app-store"
        Icon={AppleIcon}
        top="Download on the"
        bottom="App Store"
        size={size}
      />
    </div>
  );
};
